import { memo } from 'react'
import { useSnapshot } from 'valtio'

import { Button } from '@/components/ui/button'
import { chatState } from '@/store'

import ChatSendStop from '@/assets/images/chat/chat_send_stop.svg?react'
import SendIcon from '@/assets/images/icon/send.svg?react'
import ActionBar from './ActionBar'
import DeepThink from './DeepThink'
import { useStyles } from './style'

export interface ISendBtnProps {
  loading?: boolean
  curValue: string
  onSend: () => void
  onStop: () => void
}

export const SendBtn = ({
  curValue,
  loading,
  onSend,
  onStop,
}: ISendBtnProps) => {
  const { inputFileList } = useSnapshot(chatState)

  return (
    <>
      {loading ? (
        <Button
          size="icon"
          onClick={onStop}
          className="ml-[10px] size-7 rounded-full text-content-first bg-transparent hover:bg-transparent"
        >
          <ChatSendStop />
        </Button>
      ) : (
        <Button
          size="icon"
          variant="primarygradient"
          disabled={!curValue && !inputFileList.length}
          className="ml-[10px] size-7 rounded-full disabled:opacity-1 disabled:from-content-forbidden disabled:to-content-forbidden"
          onClick={onSend}
        >
          <SendIcon />
        </Button>
      )}
    </>
  )
}

const FooterAddition = (props: ISendBtnProps) => {
  const { styles } = useStyles()

  return (
    <div className={styles.footerAddition}>
      <div className="flex gap-3">
        <DeepThink />
      </div>
      <div className="flex items-center justify-center">
        <ActionBar />
        <SendBtn {...props} />
      </div>
    </div>
  )
}

export default memo(FooterAddition)
